module.exports = __webpack_public_path__ + "media/src/public/img/payment/sberbank-biz-logo-min-8ca8ac1afb1051c5f730e825932855b9.svg";